import React, { Component } from 'react';
import { Redirect, Route, Link, Switch } from 'react-router-dom';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Login from './AdminComponents/Auth/Login';



class AdminLogin extends Component {
    constructor(props)
    {
        super(props);



        this.state = {
          collapse: false,
          showError: false,
          loading: false,
          logged_in:true,
          access_token:"",
          user_details:{},

        };


    }


  render() {
      const _this=this;

      if(this.props.loginStatus)
      {
        return(<Redirect to="/admin_ui"/>);
      }

    return (
      <div>
        <div className="wrapper wrapper-full-page">
        <div className="page-header login-page header-filter" filter-color="black">

          <div className="container">




            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-8 ml-auto mr-auto">
                <Switch>
                    <Route  exact path="/admin"
                            render={(props) => <Login {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      loginStatus = {_this.props.loginStatus}
                                                                      updateAdminDetails={_this.props.updateAdminDetails} />}
                    />

                    <Route  exact path="/admin/login"
                            render={(props) => <Login {...props} base_url={_this.props.base_url}
                                                                      loginStatus = {_this.props.loginStatus}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateAdminDetails={_this.props.updateAdminDetails} />}
                    />
                   
                </Switch>



              </div>
            </div>
          </div>
          <footer className="footer">
            <div className="container">
              <nav className="float-left">
                <ul>
                  <li>
                    <Link to="https://www.etti.ac.ke">
                     ELDORET TECHNICAL TRAINING INSTITUTE
                    </Link>
                  </li>

                </ul>
              </nav>
              <div className="copyright float-right">

              </div>
            </div>
          </footer>
        </div>
      </div>

    </div>
    );
  }


}


export default AdminLogin;
